import {cn} from '@/lib/utils';
import {FiChevronLeft, FiChevronRight} from 'react-icons/fi';

type Props = {
  className?: string;
  pagesTotal: number;
  currentPage: number;
  handleGoToNextPage: () => void;
  handleGoToPreviousPage: () => void;
  handlePageClick: (page: number) => void;
};

export default function ReviewsSectionPagination({
  className,
  pagesTotal,
  currentPage,
  handleGoToNextPage,
  handleGoToPreviousPage,
  handlePageClick,
}: Props) {
  function getPagesArray() {
    let pages: number[] = [];
    for (let i = 1; i <= pagesTotal; i++) {
      pages.push(i);
    }
    return pages;
  }

  const pages = getPagesArray();

  function scrollToTop() {
    const headerRoot = document.getElementById('reviews-ref');
    if (headerRoot) {
      headerRoot.scrollIntoView({behavior: 'smooth'});
    }
  }

  return (
    <div className={className}>
      <div className="whitespace-nowrap py-[2px] px-[5px] text-gray-850 font-bold flex flex-wrap justify-center">
        <button
          type="button"
          id="reviews-previous"
          aria-label="Go to review previous page"
          onClick={() => {
            if (currentPage !== 1 && pagesTotal > 0) {
              handleGoToPreviousPage();
              scrollToTop();
            }
          }}
          className={cn(
            'h-[44px] w-11 leading-[44px] mx-[5px] bg-gray-200 min-w-7 text-gray-850',
            {
              'text-gray-500 cursor-not-allowed':
                currentPage === 1 || pagesTotal == 0,
            },
          )}>
          <FiChevronLeft className="w-5 h-5 mx-auto" />
        </button>
        <ul className="flex">
          {pages.map((page) => (
            <li
              onClick={() => {
                if (page !== currentPage) {
                  handlePageClick(page);
                  scrollToTop();
                }
              }}
              key={page}
              className={cn(
                'flex items-center justify-center h-[44px] w-11 leading-[44px] text-base mx-[5px] bg-gray-200 min-w-7 text-gray-850 cursor-pointer',
                {
                  'bg-blue text-white': currentPage === page,
                },
              )}>
              {page}
            </li>
          ))}
        </ul>
        <button
          id="reviews-next"
          aria-label="Go to review next page"
          onClick={() => {
            if (currentPage !== pagesTotal && pagesTotal > 0) {
              handleGoToNextPage();
              scrollToTop();
            }
          }}
          className={cn(
            'h-[44px] w-11 leading-[44px] mx-[5px] bg-gray-200 min-w-7 text-gray-850',
            {
              'text-gray-500 cursor-not-allowed':
                currentPage === pagesTotal || pagesTotal == 0,
            },
          )}>
          <FiChevronRight className="mx-auto w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
